// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n1-3";
export var downloadButton = "_n1-4";
export var fileContainer = "_n1-9 _n1-7";
export var fileContainerBase = "_n1-7";
export var fileContainerFixedHeight = "_n1-8 _n1-7";
export var fileInfo = "_n1-5";
export var fileInfoWidthRestricted = "_n1-6";
export var fileType = "_n1-1";
export var fileTypeName = "_n1-2";
export var image = "_n1-0";
export var link = "_n1-b";
export var overflowEllipsis = "_n1-a";